import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntGarantie: SelectDataObject[] = [
    { i: 90, t: 'Herstellereigene Garantie 72 Monate ab Erstzulassung' },
    { i: 89, t: '7 Jahre MG-Herstellergarantie (max. 150.000km) ab EZ' },
    { i: 88, t: 'Ford Protect Garantie-Schutzbrief 5. Jahr ab EZ bis max. 200.000 km' },
    { i: 87, t: 'Ford Protect Garantie-Schutzbrief 7. Jahr ab EZ bis max. 100.000 km' },
    { i: 86, t: 'Anschlussgarantie 2 Jahre bis 90.000km' },
    { i: 85, t: 'Herstellergarantie 5 Jahre bis 50.000km' },
    { i: 80, t: 'Ford Protect Garantie-Schutzbrief 3.-5. Jahr ab EZ bis max. 75.000 km' },
    { i: 79, t: '12 Monate Gebrauchtwagengarantie inklusive' },
    { i: 78, t: '5 Jahre Hyundai Herstellergarantie ohne Kilometerlimit' },
    { i: 77, t: 'Ford Protect Garantie-Schutzbrief 6.Jahr ab EZ bis max. 60.000 km' },
    { i: 76, t: 'Ford Protect Garantie-Schutzbrief 7.Jahr ab EZ bis max. 70.000 km' },
    { i: 75, t: 'Ford Protect Garantie-Schutzbrief 3.-4. Jahr ab EZ bis max. 100.000 km' },
    { i: 74, t: '7 Jahre KIA Garantie bis 150.000 KM ab Tag der 1. Zulassung' },
    { i: 73, t: 'Ford Protect Garantie-Schutzbrief 7.Jahr ab EZ bis max. 140.000 km' },
    { i: 72, t: 'Ford Protect Garantie-Schutzbrief 3.-5. Jahr ab EZ bis max. 50.000 km' },
    { i: 60, t: 'Anschlussgarantie' },
    { i: 81, t: 'Anschlussgarantie 3 Jahre, max. 200.000 km' }, // Volkswagen Garantie
    { i: 59, t: 'Anschlussgarantie 3 Jahre, max. 150.000 km' }, // Volkswagen Garantie
    { i: 58, t: 'Anschlussgarantie 3 Jahre, max. 100.000 km' }, // Volkswagen Garantie
    { i: 57, t: 'Anschlussgarantie 3 Jahre, max. 50.000 km' }, // Volkswagen Garantie
    { i: 56, t: 'Anschlussgarantie 2 Jahre, max. 120.000 km' }, // Volkswagen Garantie
    { i: 55, t: 'Anschlussgarantie 2 Jahre, max. 80.000 km' }, // Volkswagen Garantie
    { i: 54, t: 'Anschlussgarantie 2 Jahre, max. 40.000 km' }, // Volkswagen Garantie
    { i: 53, t: 'Anschlussgarantie 1 Jahr, max. 90.000 km' }, // Volkswagen Garantie
    { i: 52, t: 'Anschlussgarantie 1 Jahr, max. 60.000 km' }, // Volkswagen Garantie
    { i: 51, t: 'Anschlussgarantie 1 Jahr, max. 30.000 km' }, // Volkswagen Garantie
    { i: 50, t: 'Audi Gebrauchtwagen Plus Garantie optional' }, // Audi Garantie
    { i: 49, t: 'Anschlussgarantie 3 Jahre, max. 150.000 km' }, // Audi Garantie
    { i: 48, t: 'Anschlussgarantie 3 Jahre, max. 100.000 km' }, // Audi Garantie
    { i: 47, t: 'Anschlussgarantie 3 Jahre, max. 50.000 km' }, // Audi Garantie
    { i: 84, t: 'Anschlussgarantie 3 Jahre' }, // Audi Garantie
    { i: 46, t: 'Anschlussgarantie 2 Jahre, max. 120.000 km' }, // Audi Garantie
    { i: 86, t: 'Anschlussgarantie 2 Jahre, max. 90.000 km' }, // Audi Garantie
    { i: 45, t: 'Anschlussgarantie 2 Jahre, max. 80.000 km' }, // Audi Garantie
    { i: 44, t: 'Anschlussgarantie 2 Jahre, max. 40.000 km' }, // Audi Garantie
    { i: 83, t: 'Anschlussgarantie 2 Jahre' }, // Audi Garantie
    { i: 43, t: 'Anschlussgarantie 1 Jahr, max. 150.000 km' }, // Audi Garantie
    { i: 42, t: 'Anschlussgarantie 1 Jahr, max. 120.000 km' }, // Audi Garantie
    { i: 41, t: 'Anschlussgarantie 1 Jahr, max. 90.000 km' }, // Audi Garantie
    { i: 40, t: 'Anschlussgarantie 1 Jahr, max. 60.000 km' }, // Audi Garantie
    { i: 39, t: 'Anschlussgarantie 1 Jahr, max. 30.000 km' }, // Audi Garantie
    { i: 82, t: 'Anschlussgarantie 1 Jahr' }, // Audi Garantie
    { i: 37, t: 'Land Rover Approved 24 Monate' },
    { i: 36, t: 'Jaguar Approved 24 Monate' },
    { i: 35, t: 'Ford Protect Garantie-Schutzbrief 5.Jahr ab EZ bis max. 120.000 km' },
    { i: 34, t: 'Ford Protect Garantie-Schutzbrief 5.Jahr ab EZ bis max. 100.000 km' },
    { i: 33, t: 'Ford Protect Garantie-Schutzbrief 4.Jahr ab EZ bis max. 80.000 km' },
    { i: 32, t: 'Ford Protect Garantie-Schutzbrief 3.Jahr ab EZ bis max. 80.000 km' },
    { i: 31, t: 'Ford Protect Garantie-Schutzbrief 3.Jahr ab EZ bis max. 60.000 km' },
    { i: 30, t: 'Ford A1 Garantie 12 Monate' },
    { i: 29, t: 'Garantie bis zum 5. Fahrzeugjahr' },
    { i: 28, t: ':plus Garantie bis zum 5. Fahrzeugjahr' },
    { i: 27, t: 'Garantie 12 Monate' },
    { i: 26, t: 'Car Garantie 12 Monate' },
    { i: 25, t: 'Audi Gebrauchtwagen Plus Garantie' },
    { i: 24, t: '5 Jahre Herstellergarantie bis 100.000km' },
    { i: 23, t: 'PerfectCar Garantie 12 Monate' },
    { i: 21, t: 'Hersteller inkl. GW-Garantie' },
    { i: 20, t: 'Car Garantie' },
    { i: 19, t: 'Händlereigene Garantie 60 Monate' },
    { i: 18, t: 'Händlereigene Garantie 48 Monate' },
    { i: 17, t: 'Händlereigene Garantie 36 Monate' },
    { i: 16, t: 'Händlereigene Garantie 24 Monate' },
    { i: 15, t: 'Händlereigene Garantie 12 Monate' },
    { i: 14, t: 'Herstellereigene Garantie 60 Monate ab Erstzulassung' },
    { i: 13, t: 'Herstellereigene Garantie 48 Monate ab Erstzulassung' },
    { i: 12, t: 'Herstellereigene Garantie 36 Monate ab Erstzulassung' },
    { i: 11, t: 'Herstellereigene Garantie 24 Monate ab Erstzulassung' },
    { i: 10, t: 'Herstellereigene Garantie 12 Monate ab Erstzulassung' },
    { i: 9, t: 'Herstellereigene Garantie' },
    { i: 8, t: 'Garantie' },
    { i: 7, t: 'Careport' },
    { i: 6, t: 'Audi Anschlussgarantie' },
    { i: 5, t: 'Audi CarLifePlus' },
    { i: 4, t: 'Händlereigene Garantie' },
    { i: 3, t: 'Garantie freier Anbieter' },
    { i: 2, t: 'Volkswagen Garantie' },
    { i: 1, t: 'Audi Garantie' },
    { i: 0, t: '(keine Garantie)' },
];
export default sIntGarantie;
